import categories from '../../assets/images/categories.svg'
import topics from '../../assets/images/topics.svg'
import authors from '../../assets/images/authors.svg'
import podcasts from '../../assets/images/podcasts.svg'
import episodes from '../../assets/images/episodes.svg'

const scrollMenuItems = [
  {
    id: '1',
    title: 'Categories',
    img: categories,
  },
  {
    id: '2',
    title: 'Topics',
    img: topics,
  },
  {
    id: '3',
    title: 'Authors',
    img: authors,
  },
  {
    id: '4',
    title: 'Podcasts',
    img: podcasts,
  },
  {
    id: '5',
    title: 'Episodes',
    img: episodes,
  },
]

export default scrollMenuItems
